/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gd_Notify_Target_Discord_PhInputs */

const en_gd_notify_target_discord_ph = /** @type {(inputs: Gd_Notify_Target_Discord_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://discord.com/api/webhooks/…`)
};

const id_gd_notify_target_discord_ph = /** @type {(inputs: Gd_Notify_Target_Discord_PhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://discord.com/api/webhooks/…`)
};

/**
* | output |
* | --- |
* | "https://discord.com/api/webhooks/…" |
*
* @param {Gd_Notify_Target_Discord_PhInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const gd_notify_target_discord_ph = /** @type {((inputs?: Gd_Notify_Target_Discord_PhInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gd_Notify_Target_Discord_PhInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_gd_notify_target_discord_ph(inputs)
	return en_gd_notify_target_discord_ph(inputs)
});